import {
  styled,
  Dialog,
  dialogClasses,
  DialogContent,
  DialogActions,
  Button,
} from '@mui/material';
import { TabPanel, LoadingButton } from '@mui/lab';

export const DialogIntegrationAssignWarehousesContainer = styled(Dialog)({
  [`& .${dialogClasses.paper}`]: {
    maxWidth: 570,
    width: '100%',
    minHeight: 365,
  },
});

export const DialogIntegrationAssignWarehousesLoadingContainer = styled('div')({
  display: 'flex',
  justifyContent: 'center',
  alignItems: 'center',
  height: '100%',
  flex: 1,
});

export const DialogIntegrationAssignWarehousesContentContainer = styled(
  DialogContent,
)({
  display: 'flex',
  flex: 1,
});

export const DialogIntegrationAssignWarehousesTabPanel = styled(TabPanel)({
  display: 'flex',
  padding: 0,
  flex: 1,
  height: '100%',
});

export const DialogIntegrationAssignWarehousesActions = styled(DialogActions)({
  justifyContent: 'space-between',
});

export const DialogIntegrationAssignWarehousesActionsButton = styled(Button)({
  minWidth: 100,
});

export const DialogIntegrationAssignWarehousesActionsButtonLoading = styled(
  LoadingButton,
)({
  minWidth: 100,
});
